<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="1000">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            Listagem de Formações por Status
          </div>
        </v-toolbar>
        <div class="container dialog mt-4">
          <h3>
            Listagem de Formações por Status
          </h3>
          <v-row class="justify-center">
            <v-data-table
                class="mt-5 full-width"
                :headers="headers"
                :items="lists.formacoes"
                :items-per-page="10"
                :footer-props="$footerProps"
            >
            </v-data-table>
          </v-row>
        </div>
        <v-row class="d-flex justify-center total-participantes">
          <p>Quantidade de Formações: {{ lists.formacoes?.length || 0 }}</p>
        </v-row>
        <v-row  class="d-flex justify-center mt-4 mb-4" style="gap:2rem;">
          <v-btn outlined color="primary" @click="$emit('onClose')">Voltar</v-btn>
          <v-btn color="primary" class="mr-3" @click="baixarRelatorioPdf">Exportar</v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import {Dashboard} from "commons/classes/dashboard";
import DashboardFormacaoService from "services/dashboard-formacao.service";

export default {
  props: new DialogProps(Dashboard),
  mixins: [DashboardFormacaoService],
  data: () => ({
    lists: {
      formacoes: [],
    },
    headers: [
    ]
  }),
  methods: {
    getFormacoes() {
      this.$buscarDashboardStatusFormacao({ params: {
        GreCodigo: this.content.id,
        OrigemId: this.content?.origemId,
        EscolaCodigo: this.content?.escolaCodigo,
      }}).then(
          ({ data }) => this.lists.formacoes= data.lista
      )
    },
    async baixarRelatorioPdf() {
      this.showPageLoading();
      try {
        const { data } = await this.$buscarDashboardStatusFormacaoPdf(this.$montarParamsFilters(
            {GreCodigo: this.content.id, OrigemId: this.content?.origemId, escolaCodigo: this.content?.escolaCodigo}));
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SIGFOCO.ListagemdeFormaçõesPorStatus.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
      } finally {
        this.hidePageLoading();
      }
    },
  },
  mounted() {
    this.headers = [
      { text: "Formação", align: "center", value: "formacao" },
      { text: "Status", align: "center", value: "status" },
      ...(this.content.origemId === 1
        ? [{ text: "GRE", align: "center", value: "gre" }]
        : []),
      { text: "Responsável", align: "center", value: "responsavel" },
    ]
    this.getFormacoes();
  },
}
</script>
<style scoped>

.total-participantes {
  font-size: 0.8rem;
  margin-top: -2.7rem;
  margin-left: -20rem;
}
.full-width {
  width: 100%;
}

.v-data-table {
  table-layout: fixed;
  width: 100%;
}

.v-data-table__wrapper {
  min-height: 400px;
}
</style>